<template>
	<span v-if="data || $slots.default" v-show="data.name || $slots.default" class="c-state" :type="type" :style="compStyle" @click="$emit('click')">
		<span v-if="$slots.default"><slot></slot></span>
		<span v-else>{{data.name}} <slot name="prepend"></slot></span>
		<i v-if="angle" class="c-state-tri tf">&#xe736;</i>
	</span>
</template>

<script>
	import {mapState} from 'vuex'
	
	export default {
		name: 'cState',
		
		props: {
			dict: String,
			value: [Number, String],
			color: {
				type: [Boolean, String],
				default: true
			},
			type: String,
			angle: Boolean
		},
		
		data() {
			return {
				colorDict: {
					gray: '#999999',
					blue: '#0D6EFE',
					red: '#FF0000',
					green: '#00ACA9',
					yellow: '#FFAE00',
					orange: '#FF6900'
				}
			}
		},
		
		computed: {
			...mapState(['dictData', 'asyncDictData']),

			async() {
				return !this.dictData[this.dict];
			},
			
			compDictData() {
				if (this.async) {
					return this.asyncDictData[this.dict];
				} else {
					return this.dictData[this.dict];
				}
			},
			
			data() {
				return this.compDictData ? this.compDictData[this.value] : {name: this.value};
			},

			compStyle() {
				let color = typeof this.color == 'string' ? this.color : this.colorDict[this.data.color] || this.data.color;
				return this.type == 'state' ? {
					'color': color,
					'background': this.hex2Rgb(color, 0.05)
				} : this.type ? {
					'border-color': color,
					'color': this.type == 'hollow' ? color : '#fff',
					'background': this.type == 'hollow' ? '#fff' : color
				} : {
					'color': this.color ? color : ''
				}
			}
		},
		
		created() {
			if (this.async && this.dict && !this.compDictData) {
				this.$store.dispatch('getAsyncDict', this.dict);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.c-state {
		display: inline-block;
		vertical-align: top;
		
		&[type] {
			box-sizing: border-box;
			height: .36rem;
			border-width: .02rem;
			border-style: solid;
			padding: 0 .08rem;
			border-radius: .04rem;
			line-height: .34rem;
			font-size: .24rem;
		}
		
		&[type=state] {
			height: .44rem;
			border: none;
			padding: 0 .12rem;
			line-height: .46rem;
			font-size: .26rem;
		}

		&-tri {
			margin-left: .06rem;
			font-size: .8em;
		}
	}
</style>